<div #swiperContainer class="swiper" [ngClass]="cssClass ? cssClass : ''">
  <div class="swiper-wrapper">
    <ng-content></ng-content>
  </div>

  <div class="my-swiper-pagination"></div>
  
  <ng-container *ngIf="navigation">
    @if(navigationDesign === 'default') {
    <div class="my-swiper-nav">
      <div class="my-swiper-next bottom"><i class="fas fa-chevron-right"></i></div>
      <div class="my-swiper-prev top"><i class="fas fa-chevron-left"></i></div>
    </div>
    }@else if(navigationDesign === 'arrows-right') {
    <div class="my-swiper-nav-2">
      <div class="my-swiper-prev"><i class="fa-solid fa-arrow-left"></i></div>
      <div class="my-swiper-next"><i class="fa-solid fa-arrow-right"></i></div>
    </div>
    }
  </ng-container>
</div>
